module.exports = __webpack_public_path__ + "static/media/RED COMPLAINTS.b19f2ee8.svg";